<template>
  <aside v-if="visivel" class="cookie-consent" aria-label="Aviso de cookies">
    <div class="cookie-consent__content">
      <h2 class="cookie-consent__title">Sua privacidade importa</h2>
      <p class="cookie-consent__text">
        Utilizamos cookies necessários para o funcionamento da WiseCalc. Com sua
        autorização, também usamos cookies de análise para entender o uso da
        plataforma e melhorar sua experiência. Você pode recusar os cookies de
        análise sem perder acesso ao serviço.
        <router-link to="/privacy" class="cookie-consent__link" @click="fechar">
          Saiba mais na Política de Privacidade.
        </router-link>
      </p>
    </div>

    <div class="cookie-consent__actions">
      <button type="button" class="cookie-consent__button cookie-consent__button--secondary" @click="recusar">
        Recusar análise
      </button>
      <button type="button" class="cookie-consent__button cookie-consent__button--primary" @click="aceitar">
        Aceitar cookies de análise
      </button>
    </div>
  </aside>
</template>

<script>
const CONSENT_KEY = "wisecalc.cookie-consent";

export default {
  name: "CookieConsent",

  data() {
    return {
      visivel: false,
    };
  },

  mounted() {
    this.visivel = !localStorage.getItem(CONSENT_KEY);
  },

  methods: {
    aceitar() {
      this.salvarConsentimento("accepted");
      window.dispatchEvent(new CustomEvent("wisecalc:cookie-consent", { detail: "accepted" }));
    },

    recusar() {
      this.salvarConsentimento("rejected");
    },

    fechar() {
      this.visivel = false;
    },

    salvarConsentimento(valor) {
      localStorage.setItem(CONSENT_KEY, valor);
      this.visivel = false;
    },
  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 24px;
  z-index: 1050;
  display: flex;
  gap: 24px;
  align-items: center;
  width: min(calc(100% - 48px), 920px);
  padding: 20px 24px;
  color: #172033;
  background: #ffffff;
  border: 1px solid #d8dee9;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgb(23 32 51 / 18%);
  margin: 0 auto;
}

.cookie-consent__content {
  flex: 1;
}

.cookie-consent__title {
  margin: 0 0 6px;
  font-size: 1rem;
  font-weight: 700;
}

.cookie-consent__text {
  margin: 0;
  color: #4d596b;
  font-size: 0.875rem;
  line-height: 1.5;
}

.cookie-consent__link {
  color: #0056ff;
  font-weight: 600;
  text-decoration: underline;
}

.cookie-consent__actions {
  display: flex;
  flex-shrink: 0;
  gap: 10px;
}

.cookie-consent__button {
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid #0056ff;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 700;
  cursor: pointer;
}

.cookie-consent__button--secondary {
  color: #0056ff;
  background: #ffffff;
}

.cookie-consent__button--primary {
  color: #ffffff;
  background: #0056ff;
}

@media (max-width: 700px) {
  .cookie-consent {
    right: 12px;
    left: 12px;
    width: auto;
    bottom: 12px;
    display: block;
    padding: 18px;
    margin: 0;
  }

  .cookie-consent__actions {
    margin-top: 16px;
  }

  .cookie-consent__button {
    flex: 1;
  }
}
</style>